import type { ReactNode } from 'react';
import { memo } from 'react';

import ErrorPage from '../../pages/error';

import { useHandleError } from '@apps/uefa-tv/hooks/useHandleError';
import { useUser } from '@shared/hooks/useUser';

const AppShell = ({ children, placeholder }: { children: ReactNode; placeholder: ReactNode }) => {
  const { isLoading } = useUser();
  const error = useHandleError();

  if (error) return <ErrorPage />;

  return <>{isLoading ? placeholder : children}</>;
};

export default memo(AppShell);
